import Api from "@/services/api";

const basic = "triplist";
export default {
  get(active) {
    return Api.default().get("/" + basic + "?limit=100&active=" + active);
  },
  getOne(id) {
    return Api.default().get("/" + basic + "/" + id);
  },
  postTripList(param) {
    return Api.default().post("/" + basic + "/search", param);
  },
};
